module.exports = __webpack_public_path__ + "img/sign-17.9b79225d.jpg";